export default "__VITE_ASSET__CzvPCSLY__"